import { PremiumPurchasePlatformModule } from '@wix/premium-purchase-platform/@sdk';
import { useMemo } from 'react';
export const useFormatPrice = () => {
  var _offeringQuery$data;
  const p3Context = PremiumPurchasePlatformModule.internals.useContext();
  const offeringQuery = PremiumPurchasePlatformModule.SDK.ApiClient.hooks.useGetPurchaseUserOffering(p3Context, true);
  const currencySettings = (_offeringQuery$data = offeringQuery.data) == null ? void 0 : _offeringQuery$data.currencySettings;
  const formatPrice = useMemo(() => {
    if (!currencySettings) {
      return (price, _options) => {
        if (price === undefined) {
          return '';
        }
        return '';
      };
    }
    const formatter = PremiumPurchasePlatformModule.SDK.CurrencyUtils.createCurrencyFormatter({
      currencySettings
    });
    return (price, options) => {
      if (price === undefined || isNaN(price) || !currencySettings.code) {
        return '';
      }
      const money = {
        amount: price.toString(),
        currency: currencySettings.code
      };
      return formatter.format(money, {
        hideZeroDecimals: options == null ? void 0 : options.hideDecimalPlaces
      });
    };
  }, [currencySettings]);
  return formatPrice;
};
//# sourceMappingURL=useFormatPrice.js.map